import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLastLocation } from 'react-router-last-location';
import { Field, FieldArray, reduxForm, arrayPush, arrayRemove, arrayPop, arrayRemoveAll, initialize, change, clearFields } from 'redux-form';
import { NavLink } from "react-router-dom";
import { SiteWrapper, SearchItemSideBar } from "../common";
import { Page, Card, Button, Form, List, Badge, Dimmer, Alert, Table, Media, Text, Dropdown, Icon } from "tabler-react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Multiselect from 'react-widgets/lib/Multiselect';
import * as moment from 'moment';
import { findInventoryItems, uploadMedia, findPhotos, findPhotoDocuments, addPhotoDocument, deletePhotoDocument, getWorkItemByReferenceNum, updateWorkItem, findUsers, createWorkItemActivity, createNotifications, deleteWorkItem, updateWorkItemActivity, patchWorkItem, findPhotosByIds, removeWorkItemActivity } from '../actions';
import { confirmAlert } from 'react-confirm-alert';
import { RequisitionSettings } from './';
import SelectSearch from 'react-select-search'

import Auth from '../auth/auth';
import { forEach } from 'lodash-es';

const auth = new Auth({});
const formName = 'RequisitionItemForm';

class RequisitionItemFormPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      workItem: {},
      photoNo: "",
      photoDocuments: [],
      commentPhotoNo: "",
      getWorkItemLoader: false,
      submitLoader: false,
      deleteLoader: false,
      isCheckedLoader: false,
      isLockedLoader: false,
      inventoryItems: [],
      openSidebar: false,
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      },
      photosById: []
    };

    this.renderTextField = this.renderTextField.bind(this);
    this.renderAsterisk = this.renderAsterisk.bind(this);
    this.renderTextAreaField = this.renderTextAreaField.bind(this);
    this.renderDateField = this.renderDateField.bind(this);
    this.renderFileInput = this.renderFileInput.bind(this);
    this.renderBtnFileInput = this.renderBtnFileInput.bind(this);
    this.renderItemUploadedFiles = this.renderItemUploadedFiles.bind(this);
    this.populateAssignees = this.populateAssignees.bind(this);
    this.renderAssigneeActions = this.renderAssigneeActions.bind(this);
    this.renderActivities = this.renderActivities.bind(this);
    this.renderItemUploadedPhoto = this.renderItemUploadedPhoto.bind(this);
    this.onComment = this.onComment.bind(this);
    this.goBack = this.goBack.bind(this);
    this.afterAction = this.afterAction.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.handleLockOrCheck = this.handleLockOrCheck.bind(this);
    this.handleLockOrCheckAssignees = this.handleLockOrCheckAssignees.bind(this);
    this.onToggleEditAdminProgress = this.onToggleEditAdminProgress.bind(this);
    this.onRemoveItemUploadFile = this.onRemoveItemUploadFile.bind(this);
    this.onRemoveComment = this.onRemoveComment.bind(this);
    this.onDeleteWorkActivities = this.onDeleteWorkActivities.bind(this);
    this.onToggleEditFileItemUpload = this.onToggleEditFileItemUpload.bind(this);
    this.onUpdateComment = this.onUpdateComment.bind(this);
    this.onSelectItem = this.onSelectItem.bind(this);
    this.onSelectPhoto = this.onSelectPhoto.bind(this);
    this.onSelectCommentPhoto = this.onSelectCommentPhoto.bind(this);
  }

  async componentDidMount() {
    const { id } = this.props.match.params;

    //console.log("componentDidMount", id);
    if (id) {
      this.getWorkItemByReferenceNum(id);
    }
    else {
      this.props.clearFields(formName);
    }

    this.props.findUsers(1, 1000000);
    if (this.isCreator) {
      this.props.findPhotos(auth.name);
      await this.props.findPhotoDocuments('ERP', id);
      this.setState({ photoDocuments: this.props.photoDocuments });
    }

    console.log("componentDidMount", this.props, this.state);
  }

  getWorkItemByReferenceNum(id) {
    this.setState({ getWorkItemLoader: true });
    this.props.getWorkItemByReferenceNum(id, (response) => {
      console.log('getWorkItemByReferenceNum', response);
      let { data } = response;
      data.uploadComments = [];
      data.imageUrl = data.image !== null ? data.image.raw : null;
      data.previousStatus = data.status;
      data.previousAssignees = data.assignees;
      data.previousSpectators = data.spectators;
      data.workRequestId = data.workRequest.id;
      data.enableWatch = data.watchers.filter(w => w.toLowerCase() === auth.name.toLowerCase()).length > 0;

      // this.setState({ workItem: data, getWorkItemLoader: false }, () => {
      //   this.props.initialize(formName, data);
      // });

      //This whole list is support comment with Photos
      var ids = [];
      for (var i = 0; i < data.activities.length; ++i) {
        let uploads = data.activities[i].uploads;
        for (var k = 0; k < uploads.length; ++k) {
          if (uploads[k].extension == null || uploads[k].extension == "") {
            let splitId = (uploads[k].name.split("--"))[1];
            if (ids.indexOf(splitId) === -1) {
              ids.push(splitId);
            }
          }
        }
      }

      for (var i = 0; i < data.uploads.length; ++i) {
        if (data.uploads[i].extension == null || data.uploads[i].extension == "") {
          let splitId = (data.uploads[i].name.split("--"))[1];
          if (ids.indexOf(splitId) === -1) {
            ids.push(splitId);
          }
        }
      }

      if (ids.length > 0) {
        this.props.findPhotosByIds(auth.name, ids.join("|"), (response) => {
          let photoDatas = response.data;
          for (var i = 0; i < photoDatas.items.length; ++i) {
            let photoData = photoDatas.items[i];

            for (var k = 0; k < data.uploads.length; ++k) {
              var upload = data.uploads[k];

              console.log("upload name", upload.name, photoData.id);
              if (upload.name.indexOf(photoData.id) > -1) {
                upload.title = `${photoData.title}`;
                upload.medias = photoData.medias;
              }
            }

            for (var k = 0; k < data.activities.length; ++k) {
              let uploads = data.activities[k].uploads;

              for (var e = 0; e < uploads.length; ++e) {
                let upload = uploads[e];
                if (upload.name.indexOf(photoData.id) > -1) {
                  upload.title = `${photoData.title}`;
                  upload.medias = photoData.medias;
                }
              }
            }
          }

          this.setState({ workItem: data, getWorkItemLoader: false }, () => {
            this.props.initialize(formName, data);
          });

        });
      }
      else
        this.setState({ workItem: data, getWorkItemLoader: false }, () => {
          this.props.initialize(formName, data);
        });
    });


  }

  isCreator(workItem, userName = '', byPassIfAdmin = true) {
    if (userName === '') userName = auth.name;
    return (byPassIfAdmin && this.isAdmin()) || (workItem.createdBy && workItem.createdBy.toLowerCase() === userName.toLowerCase());
  }

  isAssignee(workItem, userName = '', byPassIfAdmin = true) {
    if (userName === '') userName = auth.name;
    return (byPassIfAdmin && this.isAdmin()) || (workItem.assignees && workItem.assignees.length > 0 && workItem.assignees.filter(a => a.userName.toLowerCase() === userName.toLowerCase()).length > 0);
  }

  isAssigneeLock(workItem, userName = '', byPassIfAdmin = true) {
    if (userName === '') userName = auth.name;
    return (byPassIfAdmin && this.isAdmin()) || (workItem.assignees && workItem.assignees.length > 0 && workItem.assignees.filter(a => a.userName.toLowerCase() === userName.toLowerCase() && (a.isLocked != null && a.isLocked)).length > 0);
  }

  isSpectator(workItem, userName = '') {
    if (userName === '') userName = auth.name;
    return workItem.spectators && workItem.spectators.length > 0 && workItem.spectators.filter(a => a.toLowerCase() === userName.toLowerCase()).length > 0;
  }

  isAdmin() {
    return auth.hasAccess('request', 'admin');
  }

  isImage(value) {
    if (!value) return true;
    value = value.toLowerCase();
    return value.match(/\.(jpeg|jpg|gif|png)$/) != null;
  }

  hasReference(workItem) {
    return workItem && workItem.references && workItem.references.length > 0;
  }

  getFileName(value) {
    if (!value) return '';
    var splitValues = value.split('/');
    return splitValues[splitValues.length - 1];
  }

  populateAssignees() {
    if (!this.props.users.items) return [];
    let users = [];
    this.props.users.items.forEach(f => users.push(f.userName));
    return users;
  }

  calculateGridWidth() {

    const { workItem } = this.state;
    const isAdmin = this.isAdmin();
    const isAssignee = this.isAssignee(workItem);
    const isSpectator = this.isSpectator(workItem);
    const isCreator = this.isCreator(workItem);
    const hasReference = this.hasReference(workItem);
    const showAssigneeActions = (isAssignee || isSpectator || isCreator) && ((workItem.assignees && workItem.assignees.length > 0) || (workItem.spectators && workItem.spectators.length > 0));

    let baseInfoGridNum = isAdmin && showAssigneeActions && hasReference ? 3
      : !isAdmin && !showAssigneeActions && !hasReference ? 12
        : 6;

    let approverGridNum = !showAssigneeActions && hasReference ? 3
      : showAssigneeActions && hasReference ? 3
        : showAssigneeActions && !hasReference ? 3
          : 6;

    let assigneeGridNum = !isAdmin && hasReference ? 3
      : isAdmin && hasReference ? 3
        : isAdmin && !hasReference ? 3
          : 6;

    return {
      baseInfoGridNum, approverGridNum, assigneeGridNum
    };
  }

  truncate(value, max, breakWord) {
    if (value.length <= max) return value;
    let newValue = value.substr(0, max - 1);
    return `${!breakWord ? newValue.substr(0, newValue.lastIndexOf(' ')) : newValue}...`;
  }

  boldNames(content) {
    if (!content) return content;
    var result = [];
    var splitContent = content.split(' ');
    for (let c of splitContent) {
      if (c.length > 0 && c[0] === '@') c = `<b class="font-weight-bold">${c}</b>`;
      result.push(c);
    }
    return result.join(' ');
  }

  appendMentions(value) {
    let workItem = this.props.form[formName].values;
    workItem.comment = workItem.comment ? `${workItem.comment} @${value}` : `@${value}`;
    this.props.change(formName, 'comment', workItem.comment);
  }

  wasMentioned(activity) {
    let authName = `@${auth.name}`;
    var splitContent = activity.content ? activity.content.split(' ') : [];
    for (let c of splitContent) {
      if (c.toLowerCase() === authName.toLowerCase() && moment(activity.createdOn).diff(moment(), 'days') < 1) return true;
    }
    return false;
  }

  prepAssignNotification(workItemReferenceNum, assigneeName) {
    return {
      name: workItemReferenceNum,
      content: `${auth.name} assigned you in a task.`,
      read: false,
      to: assigneeName,
      url: window.location.href
    };
  }

  prepViewOnlyNotification(workItemReferenceNum, viewOnlyName) {
    return {
      name: workItemReferenceNum,
      content: `${auth.name} has set you to view a task.`,
      read: false,
      to: viewOnlyName,
      url: window.location.href
    };
  }

  prepNotification(workItemReferenceNum, name, content) {
    return {
      name: workItemReferenceNum,
      content: content,
      read: false,
      to: name,
      url: window.location.href
    };
  }

  onRemoveItemUploadFile(index, type, props) {
    const { workItem } = this.state;
    if (type !== 'activities') {
      workItem[type].splice(index, 1);
      this.setState({ workItem }, () => {
        this.props.change(formName, type, workItem[type]);
      });
    }
    else {
      const { activityIndex } = props;
      workItem[type][activityIndex].uploads.splice(index, 1);
      this.setState({ workItem }, () => {
        this.props.change(formName, `${type}[${activityIndex}].uploads`, workItem[type][activityIndex].uploads);
      });
    }
  }

  
  onRemoveComment(index) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Card>
            <Card.Body>
              <h3>Are you sure?</h3>
              <p>You want to delete this comment?</p>
              <Button.List>
                <Button type="button" color="secondary" onClick={onClose}>No</Button>
                <Button type="button" color="danger" onClick={() => {
                  this.onDeleteWorkActivities(index);
                  onClose();
                }}>Yes</Button>
              </Button.List>
            </Card.Body>
          </Card>
        )
      }
    });
  }


  onDeleteWorkActivities(index) {
    let { workItem } = this.state;
    let { activities } = workItem;
    let activity = activities[index];

    this.props.removeWorkItemActivity(activity, (response) => {
      console.log('activity', response);
      workItem.activities.splice(index, 1);

      this.setState({ workItem }, () => {
        this.props.initialize(formName, workItem);
      });
    }, (error) => {
      console.log('activity', error);
    })
  }


  onFileInputChange(inputName, files) {
    if (files.length < 1) {
      return;
    }

    let file = files[0];
    let fileSize = file.size;

    if (fileSize > process.env.REACT_APP_MAX_FILESIZE) {
      return;
    }

    this.props.uploadMedia(file, 'erp/request').then((response) => {
      const { payload: { data: { uploaded } } } = response;
      let { workItem } = this.state;
      inputName = inputName.replace('FileInput', '');

      if (!workItem[inputName]) workItem[inputName] = [];
      workItem[inputName].push(uploaded[0]);
      this.setState({ workItem }, () => {
        this.props.change(formName, inputName, workItem[inputName]);
      });

    });

  }

  onSubmit(values) {
    let notifications = [];

    // check if need to populate verifiedBy, verifiedOn and progress
    if (values.previousStatus !== values.status && values.status !== 'Pending') {
      values.verifiedBy = auth.name;
      values.verifiedOn = moment().add(8, 'h').toDate();
      values.progress = "In_Progress";
      notifications.push(this.prepNotification(values.referenceNum, this.state.workItem.createdBy, `${auth.name} has ${values.status.toLowerCase()} your task.`));
    }
    else if (values.previousStatus !== values.status && values.status === 'Pending') {
      values.verifiedBy = '';
      values.verifiedOn = null;
      values.progress = 'Pending';
    }

    if (values.status === 'Rejected') values.progress = 'Rejected';

    // check watchers
    if (values.enableWatch && values.watchers.filter(w => w.toLowerCase() === auth.name.toLowerCase()).length === 0) {
      values.watchers.push(auth.name);
    }
    else if (!values.enableWatch && values.watchers.filter(w => w.toLowerCase() === auth.name.toLowerCase()).length > 0) {
      values.watchers = values.watchers.filter(w => w.toLowerCase() !== auth.name.toLowerCase());
    }

    // for (let watcher of values.watchers) {
    //     if (watcher.toLowerCase() === auth.name.toLowerCase()) continue; // don't have to send update notification to ownself if they are the watcher and the updateWorkRequest
    //     notifications.push(this.prepNotification(values.referenceNum, watcher, `${auth.name} has updated the request.`));
    // }

    // check upload files
    // if (!values.uploadFiles) values.uploadFiles = [];
    // values.uploads = values.uploadFiles.map(u => {
    //   return { raw: u.raw, by: u.by };
    // });

    // check Assignees

    let assignees = [];
    for (let a of values.assignedTo) {
      var existingAssignee = values.assignees.find(aa => aa.userName.toLowerCase() === a.toLowerCase());
      if (!existingAssignee) {
        existingAssignee = {
          userName: a,
          status: 'In_Progress'
        };
      }
      assignees.push(existingAssignee);
    }
    values.assignees = assignees;

    // populate assign Notifications
    if (values.progress !== 'Completed' && values.progress !== 'Rejected' && values.progress !== 'Canceled' && values.assignees) {
      for (let a of values.assignees) {
        const existPreviously = values.previousAssignees.find(f => f.userName.toLowerCase() === a.userName.toLowerCase());
        console.log('exist previous', existPreviously);
        if (existPreviously) continue;
        notifications.push(this.prepAssignNotification(values.referenceNum, a.userName));
      }
      for (let s of values.spectators) {
        const existPreviously = values.previousSpectators.find(f => f.toLowerCase() === s.toLowerCase());
        if (existPreviously) continue;
        notifications.push(this.prepViewOnlyNotification(values.referenceNum, s));
      }
    }

    this.setState({ submitLoader: true });
    console.log('onSubmit', values);

    this.props.updateWorkItem(values, (response) => {
      let { referenceNum } = response.data;

      //add
      values.uploads.filter(u => !u.raw).map(p => {
        const photoId = p.name.split('--')[1];

        if (this.state.photoDocuments && this.state.photoDocuments.items) {
          if (!this.state.photoDocuments.items.find(p => p.photoId === photoId)) {
            const body = {
              photoId: photoId,
              type: "ERP",
              yourId: referenceNum
            }
            this.props.addPhotoDocument(body, (response) => {
              console.log(response);
            }, (error) => {
              alert('Error, unable to add photo document');
              console.log('addPhotoDocument', error);
            });
          }
        }
        return;
      });

      if (this.state.photoDocuments && this.state.photoDocuments.items) {
        //remove
        this.state.photoDocuments.items.map(p => {
          if (!values.uploads.find(u => !u.raw && u.name.split('--')[1] === p.photoId)) {
            this.props.deletePhotoDocument(p.id, (response) => {
              console.log(response);
            }, (error) => {
              alert('Error, unable to delete photo document');
              console.log('deletePhotoDocument', error);
            });
          }
          return;
        });
      }

      this.setState({ submitLoader: false });
      if (notifications.length > 0) this.props.createNotifications(notifications);
      localStorage.setItem(RequisitionSettings.alertKey, JSON.stringify({ display: true, icon: 'check', type: 'success', message: `Item ${referenceNum} successfully updated.` }));
      this.afterAction();
    }, (error) => {
      console.log('updateWorkItem', error);
      this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to update item.' } });
    });
  }

  goBack() {
    if (this.props.history.length > 0) this.props.history.goBack();
    else if (auth.hasAccess('request', 'admin')) this.props.history.push('/requisition/all');
    else this.props.history.push('/requisition/assigned');
  }

  afterAction() {
    const { lastLocation } = this.props;
    const pathName = localStorage.getItem(RequisitionSettings.pagePathKey);
    if (pathName) localStorage.removeItem(RequisitionSettings.pagePathKey);
    this.props.history.push(pathName ? pathName : lastLocation);
  }

  onComment() {
    let { values } = this.props.form[formName];
    if (!values) return;

    let { comment, uploadComments, id } = values;

    if (!comment) return;

    let workItemActivity = {
      workItemId: id,
      type: 'Comment',
      content: comment,
      uploads: uploadComments
    };

    console.log('onComment', workItemActivity);

    this.props.createWorkItemActivity(workItemActivity, async (response) => {
      console.log('createWorkItemActivity', response);
      const { referenceNum } = response.data;
      //add photo documents
      uploadComments.filter(u => !u.raw).map(p => {
        const photoId = p.name.split('--')[1];
        const body = {
          photoId: photoId,
          type: "ERP",
          yourId: referenceNum
        }
        this.props.addPhotoDocument(body, (response) => {
          console.log(response);
        }, (error) => {
          alert('Error, unable to add photo document');
          console.log('addPhotoDocument', error);
        });
        return;
      });

      let { workItem } = this.state;

      console.log("onComment", response.data);
      let { photos } = this.props;

      for (var i = 0; i < response.data.uploads.length; ++i) {
        let upload = response.data.uploads[i];
        if (upload.extension == null || upload.extension == "") {
          let photo = photos.items.find(b => b.id === (upload.name.split("--"))[1]);
          if (photo != null && photo.title != null || photo.title != "") {
            upload.title = photo.title;
            upload.medias = photo.medias;
          }
        }


      }

      workItem.activities.splice(0, 0, response.data);
      workItem.uploadComments = [];
      workItem.comment = '';

      this.setState({ workItem }, () => {
        this.props.initialize(formName, workItem);
      });

      // createNotification
      let notifications = [];
      let { content } = response.data;

      let splitContent = content.split(' ');
      for (let c of splitContent) {
        if (c && c.indexOf('@') === 0) {
          notifications.push({
            name: workItem.referenceNum,
            content: `${auth.name} mentioned you in a comment.`,
            read: false,
            to: c.replace('@', ''),
            url: window.location.href
          });
        }
      }

      // create notifications for watchers as well
      for (let watcher of workItem.watchers) {
        if (watcher.toLowerCase() === auth.name.toLowerCase()) continue; // don't have to send update notification to ownself if they are the watcher and they commented
        notifications.push(this.prepNotification(workItem.referenceNum, watcher, `${auth.name} has made a comment.`));
      }

      if (notifications.length > 0) this.props.createNotifications(notifications);

    }, (error) => {
      console.log('createWorkItemActivity', error);
    })
  }

  onUpdateComment(activityId) {
    let workItemActivity = this.state.workItem.activities.find(a => a.id === activityId);
    workItemActivity.workItemId = this.state.workItem.id;
    console.log('onUpdateComment', workItemActivity);
    this.props.updateWorkItemActivity(workItemActivity, (response) => {
      console.log('updateWorkItemActivity', response);
    }, (error) => {
      console.log('updateWorkItemActivity', error);
    })
  }

  onSelectItem(item) {
    let { workItem } = this.state;
    item.code = item.subItemCode;

    workItem.identifier = item.id;
    workItem.name = item.name;
    workItem.code = item.code;
    workItem.itemId = item.id;
    workItem.imageUrl = item.image.raw;
    workItem.image = item.image;
    this.setState({ workItem }, () => {
      this.props.change(formName, 'identifier', item.id);
      this.props.change(formName, 'name', item.name);
      this.props.change(formName, 'code', item.code);
      this.props.change(formName, 'itemId', item.id);
      this.props.change(formName, 'imageUrl', item.image.raw);
      this.props.change(formName, 'image', item.image);
      this.props.change(formName, 'render', item.id);
    });
  }

  onSelectPhoto() {
    let { workItem, photoNo } = this.state;
    let { photos } = this.props;

    console.log("onSelectPhoto", photoNo);

    if (!photoNo || workItem.uploads.find(u => u.name === photoNo)) return;

    let title = "";
    let medias = [];
    let photo = photos.items.find(b => b.id === (photoNo.split("--"))[1]);

    console.log("photo", photo);

    if (photo.title != null || photo.title != "") {
      title = photo.title;
      medias = photo.medias;
    }

    workItem.uploads.push({
      by: auth.name,
      extension: null,
      raw: null,
      timestamp: null,
      type: "ERP",
      name: photoNo,
      title: title,
      medias: medias
    });

    this.setState({ workItem });
  }

  onSelectCommentPhoto() {

    let { workItem, commentPhotoNo } = this.state;
    let { photos } = this.props;
    if (!commentPhotoNo || workItem.uploadComments.find(u => u.name === commentPhotoNo)) return;

    let title = "";
    let medias = [];

    let photo = photos.items.find(b => b.id === (commentPhotoNo.split("--"))[1]);
    if (photo.title != null && photo.title != "") {
      title = photo.title;
      medias = photo.medias;
    }

    workItem.uploadComments.push({
      by: auth.name,
      extension: null,
      raw: null,
      timestamp: null,
      type: "ERP",
      name: commentPhotoNo,
      title: title,
      medias: medias
    });

    this.setState({ workItem });

  }

  onToggleEditAdminProgress(assignee) {
    let { workItem } = this.state;
    for (let a of workItem.assignees) {
      if (a.userName !== assignee.userName) continue;
      a.enableAdminUpdate = !a.enableAdminUpdate;
    }
    this.setState({ workItem }, () => {
      workItem.assignees.push({ createdOn: "", progress: "", userName: "", cssClass: 'd-none' }); //used to force redux form to refresh
      this.props.change(formName, `assignees`, workItem.assignees);

      // remove from assignee after redux form refreshed
      setTimeout(() => {
        workItem.assignees.pop();
        this.props.change(formName, `assignees`, workItem.assignees);
      }, 100);

    });
  }

  onToggleEditFileItemUpload(index, type, props) {
    let { workItem } = this.state;
    if (type !== 'activities') {
      workItem[type][index].edit = !workItem[type][index].edit;
      workItem[type][index].name = this.props.form[formName].values[type][index].name;
      this.setState({ workItem }, () => {
        this.props.change(formName, `${type}[${index}]`, workItem[type][index]);
      });
    }
    else {
      const { activityIndex } = props;
      workItem[type][activityIndex].uploads[index].edit = !workItem[type][activityIndex].uploads[index].edit;
      workItem[type][activityIndex].uploads[index].name = this.props.form[formName].values[type][activityIndex].uploads[index].name;
      this.setState({ workItem }, () => {
        if (!workItem[type][activityIndex].uploads[index].edit) this.onUpdateComment(workItem[type][activityIndex].id);
        this.props.change(formName, `${type}[${activityIndex}].uploads[${index}]`, workItem[type][activityIndex].uploads[index]);
      });
    }


  }

  handleOnDelete() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Card>
            <Card.Body>
              <h3>Are you sure?</h3>
              <p>You want to delete this item?</p>
              <Button.List>
                <Button type="button" color="secondary" onClick={onClose}>No</Button>
                <Button type="button" color="danger" onClick={() => {
                  this.onDelete();
                  onClose();
                }}>Yes</Button>
              </Button.List>
            </Card.Body>
          </Card>
        )
      }
    });
  }

  onDelete() {
    const { workItem: { referenceNum } } = this.state;
    this.setState({ deleteLoader: true });
    this.props.deleteWorkItem(referenceNum, (response) => {
      console.log('deleteWorkItem', response);
      this.setState({ deleteLoader: false });
      localStorage.setItem(RequisitionSettings.alertKey, JSON.stringify({ display: true, icon: 'check', type: 'success', message: `Item ${referenceNum} successfully deleted.` }));
      this.afterAction();
    }, (error) => {
      console.log('deleteWorkItem', error);
      this.setState({ deleteLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to delete item.' } });
    });
  }

  handleLockOrCheck(type) {
    const { workItem } = this.state;


    const loaderKey = `${type}Loader`;
    this.setState({ [loaderKey]: true });
    this.props.patchWorkItem({
      referenceNum: workItem.referenceNum, patchData: [
        {
          value: !workItem[type],
          path: `/${type}`,
          op: 'replace',
        }
      ]
    }, (response) => {
      workItem[type] = response.data[type];
      this.setState({ [loaderKey]: false, workItem });
    }, (error) => {
      console.error('handleLockOrCheck', type, 'patchWorkItem', error);
      this.setState({ [loaderKey]: false });
    });
  }

  handleLockOrCheckAssignees(type, index) {

    const { workItem } = this.state;
    const { assignees } = workItem;

    const loaderKey = `${type}Loader`;
    this.setState({ [loaderKey]: true });

    if ((assignees[index])[type] == null)
      (assignees[index])[type] = true;
    else
      (assignees[index])[type] = !(assignees[index])[type];

    this.props.patchWorkItem({
      referenceNum: workItem.referenceNum, patchData: [
        {
          value: assignees,
          path: `/assignees`,
          op: 'replace',
        }
      ]
    }, (response) => {

      workItem["assignees"] = [];
      this.setState({ [loaderKey]: false, workItem });

      workItem["assignees"] = response.data["assignees"];
      this.setState({ workItem });

    }, (error) => {
      console.error('handleLockOrCheck', type, 'patchWorkItem', error);
      this.setState({ [loaderKey]: false });
    });
  }





  renderAsterisk(isRequired) {
    let asterisk;

    if (isRequired) asterisk = <span className="text-danger">*</span>;

    return asterisk;
  }

  renderTextField(field) {
    const { meta: { touched, error }, label, input, isRequired, type, value } = field;

    return (
      <Form.Group>
        {label &&
          <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
        }
        <Form.Input
          value={value ? value : ''}
          type={type ? type : 'text'}
          feedback={error}
          invalid={touched && error ? 'invalid' : undefined}
          {...input}
        />
      </Form.Group>
    );
  }

  renderToggleField(field) {
    console.log('renderToggleField', field);
    const { label, input, className } = field;

    return (
      <Form.Group className={className}>
        <Form.Switch type="checkbox" label={label} {...input} checked={input.value} />
      </Form.Group>
    );
  }

  renderTextAreaField(field) {
    const { meta: { touched, error }, label, input, isRequired, rows } = field;

    return (
      <Form.Group>
        {label &&
          <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
        }
        <Form.Textarea
          feedback={error}
          invalid={touched && error ? 'invalid' : undefined}
          {...input}
          rows={rows ? rows : 3}
        />
      </Form.Group>
    );
  }

  renderDateField(field) {
    const { meta: { touched, error }, label, input, isRequired } = field;

    return (
      <Form.Group>
        <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
        <Form.MaskedInput
          placeholder="e.g. 23/01/2018"
          mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
          feedback={error}
          invalid={touched && error ? 'invalid' : undefined}
          {...input}
        />
      </Form.Group>
    );
  }

  renderFileInput(field) {
    const { input: { name }, meta: { touched, error }, label, isRequired, className } = field;

    return (
      <Form.Group className={className}>
        {label &&
          <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
        }
        <Form.FileInput
          feedback={error}
          invalid={touched && error ? 'invalid' : undefined}
          onChange={(event) => this.onFileInputChange(name, event.target.files)}
        />
      </Form.Group>
    );
  }

  renderBtnFileInput(field) {
    const { input: { name } } = field;
    return (
      <div className="upload-btn-wrapper">
        <Button type="button" className="rounded-0" icon="paperclip" color="secondary" />
        <input type="file"
          onChange={(event) => this.onFileInputChange(name, event.target.files)}
        />
      </div>
    );
  }

  renderMultiselect({ input, data, valueField, textField, label }) {
    return (
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Multiselect
          {...input}
          onBlur={() => input.onBlur()}
          value={input.value || []} // requires value to be an array
          data={data}
          valueField={valueField}
          textField={textField}
          filter="contains"
        />
      </Form.Group>
    );
  }

  renderItemUploadedPhoto(upload) {

    let title = "";
    if (upload != null && upload.title != null && upload.title != "") {
      title = upload.title;
    }

    return (
      <div>
        <a href={`${process.env.REACT_APP_ESIGN_API_HOST}/photos/${upload.name.split('--')[1]}`} target="_blank">
          {!upload.extension ? `${upload.name.split('--')[0]} ${title}` : ''}
        </a>
        {
          upload.medias &&
          <List>
            {upload.medias.map((i, index) => (
              <List.Item key={index}><a href={`${i.url}`} target="_blank">{`${i.fileName}`}</a></List.Item>
            ))
            }
          </List>
        }
      </div>
    );
  }


  renderItemUploadedFiles(upload, index, type, props = {}) {
    const { inline, activityIndex } = props;
    const { workItem } = this.state;
    const isAdmin = this.isAdmin();
    // const activity = activityIndex !== null ? workItem.activities[activityIndex] : null;
    // const forUploadsCreatorView = (type === 'uploads' && ((this.isCreator(workItem) && workItem.progress !== 'Completed')));
    // const forAttachmentsCreatorView = (type === 'activities'  && activity && activity.createdBy.toLowerCase() === auth.name.toLowerCase());
    // console.log('test', upload);

    return (
      <List.Item inline={inline} key={index}>
        {!upload.edit && upload.extension &&
          <a href={upload.url} target="_blank">
            {upload.name ? `${upload.name}${upload.extension}` : this.getFileName(upload.raw)}
          </a>
        }
        {!upload.edit && upload.name && !upload.extension &&
          this.renderItemUploadedPhoto(upload)

          // <a href={`${process.env.REACT_APP_ESIGN_API_HOST}/photos/${upload.name.split('--')[1]}`} target="_blank">
          //   {!upload.extension ? `${upload.name.split('--')[0]}` : ''}
          // </a>
        }
        {upload.edit &&
          <Field name={`${type}${type === 'activities' ? `[${activityIndex}].uploads` : ''}[${index}].name`} component="input" className="form-control d-inline-block w-75" />
        }
        {/* {(forUploadsCreatorView || type === 'uploadComments' || forAttachmentsCreatorView || this.isAdmin()) && */}
        <span>
          {upload.extension && (upload.by === auth.name || isAdmin) &&
            <Icon className={`pl-4 text-${!upload.edit ? 'primary' : 'success'} cursor-pointer`} prefix="fe" name={!upload.edit ? 'edit-3' : 'check'} onClick={() => this.onToggleEditFileItemUpload(index, type, props)} />

          }
          {/* ((type !== 'activities' && workItem.status === 'Pending' && upload.by === auth.name) || isAdmin) &&
            <Icon className="pl-1 text-danger cursor-pointer" prefix="fe" name="trash-2" onClick={() => this.onRemoveItemUploadFile(index, type, props)} />
           */
          }
        </span>
        {/* } */}
      </List.Item>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  renderStatusOrProgress(value) {
    return (
      <span>
        <span className={`d-inline-block rounded-circle mr-2 ${value === 'Closed' || value === 'Completed' || value === 'Approved' ? 'bg-success'
          : value === 'Voided' || value === 'Deleted' || value === 'Rejected' ? 'bg-danger'
            : value === 'Canceled' ? 'bg-warning'
              : value === 'In_Progress' ? 'bg-primary'
                : 'bg-secondary'
          }`} style={{
            width: '8px', height: '8px'
          }}>
        </span>
        {value.replace('_', ' ')}
      </span>
    );
  }

  renderAssigneeActions({ fields }) {

    //This is the portions for IsCheck, IsLock, IsWrong
    const { workItem, isCheckedLoader, isLockedLoader } = this.state;
    const { assignees } = workItem;
    const { assigneeGridNum } = this.calculateGridWidth();
    const isAdmin = this.isAdmin();


    console.log("renderAssigneeActions", this.state);
    //(workItem.isLocked || workItem.isChecked)
    return fields.map((item, index) => (
      <div className={`col-md-${assigneeGridNum > 5 ? 4 : 12}`} key={index}>
        <Form.Group >
          {assignees[index] &&
            <div>
              <Form.Label>{assignees[index].userName} <small>({moment(assignees[index].createdOn).format('DD/MM/YYYY h:mm a')})</small></Form.Label>
              {((isAdmin && assignees[index].enableAdminUpdate) || (assignees[index].userName.toLowerCase() === auth.name.toLowerCase() && workItem.progress !== 'Completed' && workItem.progress !== 'Rejected')) &&
                <Field name={`${item}.progress`} className="form-control mr-2" component="select" disabled={!isAdmin && assignees[index].isLocked}>
                  <option value="Pending">Pending</option>
                  <option value="In_Progress">In Progress</option>
                  {workItem.status === 'Approved' &&
                    <option value="Completed">Completed</option>
                  }
                  <option value="Canceled">Canceled</option>
                </Field>
              }
              {(!assignees[index].enableAdminUpdate && (assignees[index].userName.toLowerCase() !== auth.name.toLowerCase() || workItem.progress === 'Completed' || workItem.progress === 'Rejected')) &&
                <div className={assignees[index].cssClass}>
                  {this.renderStatusOrProgress(assignees[index].progress)}
                  {isAdmin &&
                    <Icon className="pl-1 text-primary cursor-pointer" prefix="fe" name="edit-3" onClick={() => { this.onToggleEditAdminProgress(assignees[index]) }} />
                  }
                </div>
              }
              { /* Here is the changes. Need to be make benson   */
                <React.Fragment>
                  <br />
                  <Button className="mr-2" loading={isCheckedLoader} color={assignees[index].isChecked ? 'success' : 'secondary'} icon="check" type="button" onClick={() => this.handleLockOrCheckAssignees('isChecked', index)} disabled={!isAdmin} />
                  <Button className="mr-2" loading={isLockedLoader} color={assignees[index].isLocked ? 'warning' : 'secondary'} icon="lock" type="button" onClick={() => this.handleLockOrCheckAssignees('isLocked', index)} disabled={!isAdmin} />
                </React.Fragment>
              }
            </div>
          }

        </Form.Group>
      </div>
    ));
  }

  renderAttributeType(attribute) {
    console.log(attribute);
    switch (attribute.type) {
      case 'Link':
        return (<a href={attribute.value} target="_blank">Link</a>);
      case 'DateTime':
        return (<span>{moment(attribute.value).format('DD/MM/YYYY h:mm a')}</span>);
      case 'Array':
        return (<span>{JSON.parse(`{ "values": ${attribute.value} }`).values.join(', ')}</span>)
      default:
        return (<span>{attribute.value}</span>);
    }
  }

  renderActivities(activity, index) {

    const { workItem } = this.state;

    const isAdmin = this.isAdmin();
    const isSpectator = this.isSpectator(workItem);
    const progressEnd = workItem.progress === 'Completed' || workItem.progress === 'Rejected' || workItem.status === 'Rejected';

    let canDelete = auth.hasAccess('request', 'delete') && !isSpectator && !progressEnd;
    if (!canDelete && isAdmin) canDelete = true;




    

    const avatarUrl = `https://ui-avatars.com/api/?name=${activity.createdBy}&background=${auth.name.toLowerCase() === activity.createdBy.toLowerCase() ? '467fcf'
      : '5eba00'}&color=fff`;
    const timestamp = moment(activity.createdOn).from(moment());
    const formattedDatetime = moment(activity.createdOn).format("DD/MM/YYYY hh:mma");
    return (
      <div key={activity.id} className="list-group-item py-5">
        <Media>
          <Media.Object
            avatar
            objectURL={avatarUrl}
            size="md"
            className="mr-4"
          />
          <Media.Body>
            <Media.Heading>
              {this.wasMentioned(activity) &&
                <Badge color="danger" className="float-right ml-2">
                  <Icon name="bell" /> 1
                </Badge>
              }
              <div className="float-right text-muted text-right">
                <small className="d-block">{formattedDatetime}</small>
                <small>{timestamp}</small>
              </div>
              <h5>{activity.createdBy}</h5>
              <h6><u>{activity.referenceNum}</u></h6>
            </Media.Heading>
            <Text dangerouslySetInnerHTML={{ __html: this.boldNames(activity.content) }}>
            </Text>
            {activity.uploads.length > 0 &&
              <div className="border p-3 mt-3">
                <span><i className="fe fe-paperclip"></i> Attachments</span>
                <List className="mt-2 mb-0 pl-0">
                  {activity.uploads.map((u, uploadIndex) => this.renderItemUploadedFiles(u, uploadIndex, `activities`, { inline: true, activityIndex: index }))}
                </List>
              </div>
            }
            {
              canDelete &&
              <Icon className="pl-1 text-danger cursor-pointer" prefix="fe" name="trash-2" onClick={() => this.onRemoveComment(index)} />
            }

          </Media.Body>
        </Media>
      </div>
    );
  }

  renderActivityAttachments(activity, index) {
    return activity.uploads.map((u, i) => (
      <List.Item key={`${activity.id}_${index}_${i}`}>
        <strong className="mr-2"><u>{activity.referenceNum}</u></strong>
        <a href={u.url} target="_blank">
          {u.name}{u.extension}
        </a>
        <small className="ml-2">by <u>{activity.createdBy}</u> on <u>{moment(activity.createdOn).format('DD/MM/YYYY h:mm a')}</u></small>
      </List.Item>
    ));
  }

  render() {

    const { handleSubmit } = this.props;
    const { workItem, submitLoader, getWorkItemLoader, deleteLoader, isCheckedLoader, isLockedLoader } = this.state;
    const { workRequest, references } = workItem;
    const { baseInfoGridNum, approverGridNum, assigneeGridNum } = this.calculateGridWidth();
    const hasImage = workItem && workItem.image;
    const isImage = hasImage && this.isImage(workItem.imageUrl);

    const isAssignee = this.isAssignee(workItem);
    const isCreator = this.isCreator(workItem);
    const isAssigneeLock = this.isAssigneeLock(workItem);
    const isAdmin = this.isAdmin();
    const isSpectator = this.isSpectator(workItem);
    const progressEnd = workItem.progress === 'Completed' || workItem.progress === 'Rejected' || workItem.status === 'Rejected';
    let canDelete = auth.hasAccess('request', 'delete') && !isSpectator && !progressEnd;
    const hasIMSAccess = auth.hasAccess('purchase', 'read', 'IMS') || auth.hasAccess('adjustment', 'read', 'IMS') || auth.hasAccess('undertake', 'read', 'IMS');
    const showAssigneeActions = (isAssignee || isSpectator || isCreator) && ((workItem.assignees && workItem.assignees.length > 0) || (workItem.spectators && workItem.spectators.length > 0));
    const hasReference = this.hasReference(workItem);

    //overwrite as admin
    if (!canDelete && isAdmin) canDelete = true;

    // for specific role views
    const creatorView = (isCreator && workItem.progress !== 'Completed') || isAdmin; //&& !workItem.isLocked && !workItem.isChecked
    const assigneeView = (isAssignee && !progressEnd && !isAssigneeLock) || isAdmin; // && !workItem.isLocked && !workItem.isChecked

    console.log("workItem", workItem);
    console.log("assigneeView", isAssignee, !progressEnd, !workItem.isLocked, !workItem.isChecked);
    return (
      <SiteWrapper>
        <Page.Content>
          {this.renderAlert()}
          <Dimmer active={getWorkItemLoader} loader>
            <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="d-flex p-0 mb-3 ">
                <Button type="button" color="secondary" onClick={this.goBack}>Back</Button>
                {(creatorView || assigneeView) &&
                  <Button loading={submitLoader} color="success" className="ml-auto">Submit</Button>
                }
              </div>

              <Card>
                <Card.Header className="print">
                  <Card.Title>
                    {workItem.referenceNum}
                    {workItem && workItem.workRequest &&
                      <span>
                        /
                        <small className="mb-0 text-primary d-inline-block"><NavLink to={`/requisition/${workItem.workRequest.referenceNum}`}>{workItem.workRequest.referenceNum}</NavLink></small>
                      </span>
                    }
                    {workItem.submittedBy && workItem.submittedOn &&
                      <span className="badge badge-info ml-2"><span className="text-dark">Submitted:</span> <b className="font-weight-bold">{workItem.submittedBy}, {moment(workItem.submittedOn).format('DD/MM/YYYY h:mm a')}</b></span>
                    }
                    {workItem.status === 'Approved' && workItem.verifiedBy && workItem.verifiedOn &&
                      <span className="badge badge-success ml-2"><span className="text-dark">Verified:</span> <b className="font-weight-bold">{workItem.verifiedBy}, {moment(workItem.verifiedOn).format('DD/MM/YYYY h:mm a')}</b></span>
                    }
                    {workItem.status === 'Rejected' && workItem.verifiedBy && workItem.verifiedOn &&
                      <span className="badge badge-danger ml-2"><span className="text-dark">Rejected:</span> <b className="font-weight-bold">{workItem.verifiedBy}, {moment(workItem.verifiedOn).format('DD/MM/YYYY h:mm a')}</b></span>
                    }
                  </Card.Title>
                  <Card.Options className="no-print">
                    {/* {workItem.progress !== 'Completed' && workItem.progress !== 'Rejected' && (this.isCreator(workItem) || this.isAdmin() || (this.isAssignee(workItem) && workItem.assignees.filter(f => f.progress === 'Completed').length === workItem.assignees.length)) &&
                      <Field name="progress" className="form-control mr-2" component="select">
                         {workItem.status !== 'Approved' &&
                          <option value="Pending">Pending</option>
                         }
                         <option value="In_Progress">In Progress</option>
                         {workItem.status === 'Approved' &&
                          <option value="Completed">Completed</option>
                         }
                      </Field>
                      } */}
                    <Field label="Watch" name="enableWatch" className="mr-2 pt-2 mb-0" component={this.renderToggleField} />
                    {isAdmin &&
                      <React.Fragment>
                        <Button color="primary" type="button" className="mr-2 min-width-auto" onClick={() => this.setState({ openSidebar: !this.state.openSidebar })}>Change Item</Button>
                      </React.Fragment>
                    }
                    { /*
                        <Button loading={isCheckedLoader} className="mr-2" color={workItem.isChecked ? 'success' : 'secondary'} icon="check" type="button" onClick={() => this.handleLockOrCheck('isChecked')} />
                        <Button loading={isLockedLoader} className="mr-2" color={workItem.isLocked ? 'warning' : 'secondary'} icon="lock" type="button" onClick={() => this.handleLockOrCheck('isLocked')} />
                    */}
                    {!isAdmin && workItem.isChecked &&
                      <Button className="mr-2" color="success" icon="check" type="button" disabled />
                    }
                    {!isAdmin && workItem.isLocked &&
                      <Button className="mr-2" color="warning" icon="lock" type="button" disabled />
                    }
                    {canDelete &&
                      <Button loading={deleteLoader} color="danger" icon="trash" type="button" onClick={this.handleOnDelete} />
                    }
                    {isSpectator && !isCreator && !isAssignee &&
                      <span className="badge badge-secondary">View Only</span>
                    }
                  </Card.Options>
                </Card.Header>
                {!isAdmin && workItem.approverRemarks &&
                  <Card.Alert color="secondary">
                    Approver Remark: <strong>{workItem.approverRemarks}</strong>
                  </Card.Alert>
                }
                <Card.Body className="pb-0">

                  {/* PRF Information */}
                  {workRequest &&
                    <Card>
                      <Card.Body className="pb-0">
                        <div className="row">
                          <div className="col-sm-4">
                            <Form.Group>
                              <Form.Label className="mb-0">Title</Form.Label>
                              <Form.StaticText className="pt-0">{workRequest.name}</Form.StaticText>
                            </Form.Group>
                          </div>
                          <div className="col-sm-2">
                            <Form.Group>
                              <Form.Label className="mb-0">Request By</Form.Label>
                              <Form.StaticText className="pt-0">{workRequest.contactName}</Form.StaticText>
                            </Form.Group>
                          </div>
                          <div className="col-sm-2">
                            <Form.Group>
                              <Form.Label className="mb-0">Contact Number</Form.Label>
                              <Form.StaticText className="pt-0">{workRequest.contactNumber}</Form.StaticText>
                            </Form.Group>
                          </div>
                          <div className="col-sm-2">
                            <Form.Group>
                              <Form.Label className="mb-0">Remark/Delivery Location</Form.Label>
                              <Form.StaticText className="pt-0">{workRequest.location}</Form.StaticText>
                            </Form.Group>
                          </div>
                          <div className="col-sm-2">
                            <Form.Group>
                              <Form.Label className="mb-0">Submission Date/Delivery Date</Form.Label>
                              <Form.StaticText className="pt-0">{moment(workRequest.date).format('DD/MM/YYYY')}</Form.StaticText>
                            </Form.Group>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  }
                  {/* End PRF Information */}

                  <div className="row">

                    {/* Base Information */}
                    <div className={`col-md-${baseInfoGridNum}`}>
                      <div className="row pt-4">
                        <div className={`col-md-${baseInfoGridNum > 5 ? 6 : 12}`}>
                          <Form.Group>
                            <Table className="border-0 border-sm">
                              <Table.Body>
                                <Table.Row>
                                  <Table.Col className="border-0 w-8 p-0">
                                    {hasImage && isImage &&
                                      <img alt="" src={workItem.image.url} />
                                    }
                                    {!hasImage && !isImage &&
                                      <img alt="" src={`https://ui-avatars.com/api/?name=${workItem.name}`} />
                                    }
                                    {hasImage && !isImage &&
                                      <a href={workItem.imageUrl} target="_blank"><i className="fe fe-file" style={{ fontSize: '4em' }}></i></a>
                                    }
                                  </Table.Col>
                                  <Table.Col className="border-0 pr-0 pb-0 pt-0">
                                    <Form.Label className="mb-0">Item</Form.Label>
                                    <Form.StaticText className="pt-0">{workItem.code} - {workItem.name}</Form.StaticText>
                                  </Table.Col>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          </Form.Group>
                        </div>
                        <div className={`col-md-${baseInfoGridNum > 5 ? 3 : 12}`}>
                          {!creatorView &&
                            <Form.Group>
                              <Form.Label className="mb-0">Work Order/By KL No.</Form.Label>
                              <Form.StaticText className="pt-0">{workItem.workOrderNum}</Form.StaticText>
                            </Form.Group>
                          }
                          {creatorView &&
                            <Field name="workOrderNum" label="Work Order/By KL No." component={this.renderTextField} />
                          }
                        </div>
                        <div className={`col-md-${baseInfoGridNum > 5 ? 3 : 12}`}>
                          {!creatorView &&
                            <Form.Group>
                              <Form.Label className="mb-0">Quantity</Form.Label>
                              <Form.StaticText className="pt-0">{workItem.requestQuantity}</Form.StaticText>
                            </Form.Group>
                          }
                          {creatorView &&
                            <Field label="Quantity" name="requestQuantity" type="number" component={this.renderTextField} />
                          }
                        </div>
                        <div className={`col-md-${baseInfoGridNum > 5 ? 6 : 12}`}>
                          {!creatorView &&
                            <Form.Group>
                              <Form.Label className="mb-0">Remark</Form.Label>
                              <Form.StaticText className="pt-0 remarkText">{workItem.remarks}</Form.StaticText>
                            </Form.Group>
                          }
                          {creatorView &&
                            <Field label="Remark" name="remarks" component={this.renderTextAreaField} />
                          }
                        </div>
                        <div className={`col-md-${baseInfoGridNum > 5 ? 6 : 12}`}>
                          {!creatorView &&
                            <Form.Label className="mb-0">Uploads</Form.Label>
                          }
                          {creatorView &&
                            <Field label="Uploads" name="uploadsFileInput" component={this.renderFileInput} />
                          }
                          {(creatorView && this.props.photos.items && this.props.photos.items.length > 0) &&
                            <div className="w-100 float-left mb-3">
                              <div style={{ width: "80%" }} className="float-left">
                                <SelectSearch
                                  name="dropdownPhotos"
                                  style={{ width: "80%" }}
                                  options={this.props.photos.items.map((item) => {
                                    return { name: `${item.photoNo} - ${item.title}`, value: `${item.photoNo}--${item.id}` }
                                  })}
                                  onChange={event => this.setState({ photoNo: event.value })}
                                  value={this.state.photoNo}
                                  placeholder="Select Photo" />
                              </div>
                              <div style={{ width: "20%" }} className="float-left text-center">
                                <Button color="primary" type="button" className="ml-2 min-width-auto" onClick={() => this.onSelectPhoto()}>Add</Button>
                              </div>
                            </div>
                          }
                          <List>
                            {workItem.uploads && workItem.uploads.map((upload, index) => this.renderItemUploadedFiles(upload, index, 'uploads'))}
                          </List>
                        </div>
                      </div>
                    </div>
                    {/* End Base Information */}

                    {/* Admin Actions */}
                    {isAdmin &&
                      <div className={`col-md-${approverGridNum} border-left`}>
                        <div className="pt-4">
                          <Form.Group label="Status">
                            <label className="mr-3">
                              <Field name="status" className="mr-1" component="input" type="radio" value="Pending" />Pending
                            </label>
                            <label className="mr-3">
                              <Field name="status" className="mr-1" component="input" type="radio" value="Approved" /> <span className="text-success">Approved</span>
                            </label>
                            <label>
                              <Field name="status" className="mr-1" component="input" type="radio" value="Rejected" /> <span className="text-danger">Rejected</span>
                            </label>
                          </Form.Group>

                          <Field label="Assign To" name="assignedTo" component={this.renderMultiselect} data={this.populateAssignees()} />

                          <Field label="View Only" name="spectators" component={this.renderMultiselect} data={this.populateAssignees()} />

                          <Field label="Remark" name="approverRemarks" component={this.renderTextAreaField} />
                        </div>
                      </div>
                    }
                    {/* End Admin Actions */}

                    {/* Assignees Actions (Modify Ben) */}
                    {showAssigneeActions &&
                      <div className={`col-md-${assigneeGridNum} border-left`}>
                        <div className="row pt-4">
                          <FieldArray name="assignees" component={this.renderAssigneeActions} />
                        </div>
                        {workItem.assignees.length > 0 && workItem.spectators.length > 0 &&
                          <hr className="mt-1 mb-4" />
                        }
                        {workItem.spectators.length > 0 &&
                          <div>
                            <Form.Group label="View Only">
                              {workItem.spectators.join(', ')}
                            </Form.Group>
                          </div>
                        }
                      </div>
                    }
                    {/* End Assignees Action */}

                    {/* Reference */}
                    {hasReference &&
                      <div className="col-md-3 border-left">
                        <Tabs>
                          <TabList>
                            {references.map(r => (
                              <Tab key={r.referenceNum}>{r.referenceNum}</Tab>
                            ))}
                          </TabList>

                          {references.map(r => (
                            <TabPanel key={r.referenceNum}>
                              <Table className="table-sm border-0 pt-4">
                                <Table.Body>
                                  <Table.Row>
                                    <Table.Col className="border-0"><small className="font-weight-bold">Reference</small></Table.Col>
                                    <Table.Col className="border-0">
                                      {hasIMSAccess &&
                                        <a href={r.url} target="_blank">{r.referenceNum}</a>
                                      }
                                      {!hasIMSAccess &&
                                        <span>{r.referenceNum}</span>
                                      }
                                    </Table.Col>
                                  </Table.Row>
                                  <Table.Row>
                                    <Table.Col className="border-0"><small className="font-weight-bold">Status</small></Table.Col>
                                    <Table.Col className="border-0">
                                      {this.renderStatusOrProgress(r.status)}
                                    </Table.Col>
                                  </Table.Row>
                                  <Table.Row>
                                    <Table.Col className="border-0"><small className="font-weight-bold">Checked</small></Table.Col>
                                    <Table.Col className={r.hasChecked ? 'text-success border-0' : 'text-danger border-0'}>{r.hasChecked ? 'Yes' : 'No'}</Table.Col>
                                  </Table.Row>
                                  <Table.Row>
                                    <Table.Col className="border-0"><small className="font-weight-bold">Locked</small></Table.Col>
                                    <Table.Col className={r.isLocked ? 'text-success border-0' : 'text-danger border-0'}>{r.isLocked ? 'Yes' : 'No'}</Table.Col>
                                  </Table.Row>
                                  <Table.Row>
                                    <Table.Col className="border-0"><small className="font-weight-bold">Wrong</small></Table.Col>
                                    <Table.Col className={r.isWrong ? 'text-success border-0' : 'text-danger border-0'}>{r.isWrong ? 'Yes' : 'No'}</Table.Col>
                                  </Table.Row>
                                  {r.attributes.filter(b => b.display).map((a) => (
                                    <Table.Row key={a.key}>
                                      <Table.Col className="border-0"><small className="font-weight-bold">{a.key}</small></Table.Col>
                                      <Table.Col className="border-0">
                                        {this.renderAttributeType(a)}
                                      </Table.Col>
                                    </Table.Row>
                                  ))}
                                  <Table.Row>
                                    <Table.Col className="border-0"><small className="font-weight-bold">Uploads</small></Table.Col>
                                    <Table.Col className="border-0">
                                      <List unstyled>
                                        {r.uploads.map((u) => (
                                          <List.Item key={u.url}><a href={u.url} target="_blank">{this.truncate(u.raw.replace(/^.*[\\]/, ''), 25, true)}</a></List.Item>
                                        ))}
                                      </List>
                                    </Table.Col>
                                  </Table.Row>
                                </Table.Body>
                              </Table>
                            </TabPanel>
                          ))}


                        </Tabs>

                      </div>
                    }
                    {/* End Reference */}

                  </div>
                </Card.Body>

                {/* Comments */}
                <Card className="border-bottom-0 border-left-0 border-right-0 pt-2 mb-0">
                  <Tabs>
                    <TabList className="border-bottom mb-0">
                      <Tab>Comments</Tab>
                      <Tab>Attachments</Tab>
                    </TabList>

                    <TabPanel>
                      <Card className="mb-0 border-0">
                        <Card.Body>
                          <Form.InputGroup>
                            <Field name="comment" autoComplete="off" className="form-control" component="input" type="text" placeholder="Message" />
                            <Form.InputGroup append>
                              <Button.Dropdown className="rounded-0" type="button" icon="at-sign" color="secondary" dropdownProps={{ className: 'scroll-dropdown' }}>
                                {this.props.users && this.props.users.items && this.props.users.items.map(i => (
                                  <Dropdown.Item key={i.userName} className={
                                    this.isCreator(workItem, i.userName, false)
                                      || this.isAssignee(workItem, i.userName, false)
                                      || this.isSpectator(workItem, i.userName)
                                      || i.userName === 'natalie'
                                      ? '' : 'd-none'
                                  }>
                                    <span className="d-block cursor-pointer" onClick={() => this.appendMentions(i.userName)}>{i.userName}</span>
                                  </Dropdown.Item>
                                ))}
                              </Button.Dropdown>
                              <Field name="uploadCommentsFileInput" component={this.renderBtnFileInput} />
                              <Button type="button" color="primary" onClick={this.onComment}>Comment</Button>
                            </Form.InputGroup>
                          </Form.InputGroup>
                          <div className="row mt-3">
                            <div className="col-6">
                              <List className="mt-3">
                                {workItem.uploadComments && workItem.uploadComments.map((upload, index) => this.renderItemUploadedFiles(upload, index, 'uploadComments'))}
                              </List>
                            </div>
                            {(this.props.photos.items && this.props.photos.items.length > 0) &&
                              <div className="col-lg-6">
                                <div className="w-100 float-left mb-3">
                                  <div style={{ width: "80%" }} className="float-left">
                                    <SelectSearch
                                      name="dropdownPhotos"
                                      style={{ width: "80%" }}
                                      options={this.props.photos.items.map((item) => {
                                        return { name: `${item.photoNo} - ${item.title}`, value: `${item.photoNo}--${item.id}` }
                                      })}
                                      onChange={event => this.setState({ commentPhotoNo: event.value })}
                                      value={this.state.commentPhotoNo}
                                      placeholder="Select Photo" />
                                  </div>
                                  <div style={{ width: "20%" }} className="float-left text-center pl-2">
                                    <Button color="primary" type="button" className="w-100 min-width-auto" onClick={() => this.onSelectCommentPhoto()}>Add</Button>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </Card.Body>
                        <div className="list-group mb-0 card-list-group">
                          {workItem.activities && workItem.activities.map((a, index) => this.renderActivities(a, index))}
                        </div>
                      </Card>
                    </TabPanel>
                    <TabPanel>
                      <Card className="mb-0 border-0">
                        <Card.Body>
                          {workItem.activities && workItem.activities.filter(a => a.uploads && a.uploads.length > 0).map((a, index) => this.renderActivityAttachments(a, index))}
                        </Card.Body>
                      </Card>
                    </TabPanel>
                  </Tabs>
                </Card>
                {/* End Comments */}

              </Card>
              <div className="d-flex">
                <Button type="button" color="secondary" onClick={this.goBack}>Back</Button>
                {(creatorView || assigneeView) &&
                  <Button loading={submitLoader} color="success" className="ml-auto">Submit</Button>
                }
              </div>
            </Form>
          </Dimmer>
          <SearchItemSideBar
            isOpen={this.state.openSidebar}
            onClosed={() => this.setState({ openSidebar: false, itemToChange: { enabled: false } })}
            onSelectItem={this.onSelectItem}
          />
        </Page.Content>
      </SiteWrapper>
    );
  }
}


function validate(values) {
  const errors = {};
  return errors;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    uploadMedia,
    arrayPush,
    arrayRemove,
    arrayPop,
    updateWorkItem,
    patchWorkItem,
    deleteWorkItem,
    getWorkItemByReferenceNum,
    initialize,
    createWorkItemActivity,
    updateWorkItemActivity,
    findUsers,
    findPhotos,
    findPhotoDocuments,
    addPhotoDocument,
    deletePhotoDocument,
    arrayRemoveAll,
    change,
    createNotifications,
    clearFields,
    findInventoryItems,
    findPhotosByIds,
    removeWorkItemActivity
  }, dispatch);
}

function mapStateToProps({ photos, photoDocuments, users, form }) {
  return { photos, photoDocuments, users, form };
}

export default reduxForm({
  validate,
  form: formName
})(connect(mapStateToProps, mapDispatchToProps)(withLastLocation(RequisitionItemFormPage)))



// WEBPACK FOOTER //
// ./src/requisition/item-form.react.js